const formatPhoneNumber = (phoneNumber) => {
  // Remove special characters from the phone number
  phoneNumber = phoneNumber.replace(/[^\d]/g, '');
  if (phoneNumber) {
    if (phoneNumber.length === 10) {
      return phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
    }
    return phoneNumber;
  }
  return phoneNumber;
};

export default formatPhoneNumber;
